import { ICreateEntregaObraUseCase } from "../../../presentation/useCases/create/create_entrega_obra_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";
/**
 * CreateEntregaObraUseCase
 */


export class CreateEntregaObraUseCase implements ICreateEntregaObraUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(
    status: number,
    idCentroCusto: number,

  ): Promise<number> {
    return this.repository.createEntregaObra(
      status,
      idCentroCusto,

    );

  }
}
